import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Hourly Sales Report")
    ])
  ])
], -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-4 mt-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label"
}, "City", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "All cities", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-4 mt-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "floatingInput",
  class: "txt-right"
}, "From Date", -1)
const _hoisted_10 = { class: "col-md-3 mt-4 text-start pb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "col-12 bg-light p-3" }
const _hoisted_14 = { class: "d-flex justify-content-between" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { id: "charthourly1" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "col-12 bg-light p-3" }
const _hoisted_18 = { class: "d-flex justify-content-between" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { id: "charthourly2" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "col-12 bg-light p-3" }
const _hoisted_22 = { class: "d-flex justify-content-between" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { id: "charthourly3" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "col-12 bg-light p-3" }
const _hoisted_26 = { class: "d-flex justify-content-between" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { id: "charthourly4" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { class: "col-12 bg-light p-3" }
const _hoisted_30 = { class: "d-flex justify-content-between" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { id: "charthourly5" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = { class: "col-12 bg-light p-3" }
const _hoisted_34 = { class: "d-flex justify-content-between" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { id: "charthourly6" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = { class: "col-12 bg-light p-3" }
const _hoisted_38 = { class: "d-flex justify-content-between" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { id: "charthourly7" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formdata.city_id) = $event)),
            class: "form-control"
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cities, (city) => {
              return (_openBlock(), _createElementBlock("option", {
                key: city.id,
                value: city.id
              }, _toDisplayString(city.name), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.formdata.city_id]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_datepicker, {
            modelValue: $setup.formdata.fromdate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formdata.fromdate) = $event)),
            class: "form-control"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("button", {
            class: "btn btn-large btn-primary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.cityBasedCall && $setup.cityBasedCall(...args)))
          }, "Search")
        ])
      ])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("h2", null, "Hourly Reprt : " + _toDisplayString($options.dateTime($setup.formdata.fromdate)), 1)
      ])
    ]),
    _hoisted_15,
    _hoisted_16,
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("h2", null, "Hourly Reprt : " + _toDisplayString($options.dateTime($setup.formdata.fromdate1)), 1)
      ])
    ]),
    _hoisted_19,
    _hoisted_20,
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("h2", null, "Hourly Reprt : " + _toDisplayString($options.dateTime($setup.formdata.fromdate2)), 1)
      ])
    ]),
    _hoisted_23,
    _hoisted_24,
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("h2", null, "Hourly Reprt : " + _toDisplayString($options.dateTime($setup.formdata.fromdate3)), 1)
      ])
    ]),
    _hoisted_27,
    _hoisted_28,
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("h2", null, "Hourly Reprt : " + _toDisplayString($options.dateTime($setup.formdata.fromdate4)), 1)
      ])
    ]),
    _hoisted_31,
    _hoisted_32,
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("h2", null, "Hourly Reprt : " + _toDisplayString($options.dateTime($setup.formdata.fromdate5)), 1)
      ])
    ]),
    _hoisted_35,
    _hoisted_36,
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("h2", null, "Hourly Reprt : " + _toDisplayString($options.dateTime($setup.formdata.fromdate6)), 1)
      ])
    ]),
    _hoisted_39,
    _hoisted_40,
    _hoisted_41,
    _hoisted_42
  ], 64))
}